import React from 'react';
import { Link } from 'react-router-dom';

export default function HelpNotice({
  variant = 'sidebar',
  className = '',
}) {
  if (variant === 'banner') {
    return (
      <aside
        aria-label="Skattefaglig hjælp og rådgivning"
        className={`relative overflow-hidden rounded-md border border-slate-200 bg-white p-6 sm:p-8 shadow-xs ${className}`}
      >
        <div className="flex flex-col lg:flex-row lg:items-center lg:justify-between gap-6">
          <div className="max-w-2xl">
            <div className="flex items-center gap-2 text-xs font-bold tracking-widest text-[#fd7302] uppercase">
              <i className="fa-solid fa-scale-balanced" aria-hidden="true" />
              <span>Redaktionel rådgivningshenvisning</span>
            </div>
            <h2 className="mt-2 font-serif text-2xl sm:text-3xl font-bold text-[#010b27]">
              Har du brug for konkret hjælp til din skattesag?
            </h2>
            <p className="mt-2 text-sm sm:text-base text-slate-600 leading-relaxed">
              Skatunderlup er et redaktionelt nyhedsmedie og yder ikke konkret sagsbehandling. Ved verserende tilsyn, klagesager eller kompleks skatterådgivning henviser vi til skattefaglig rådgiver Martin Krogh.
            </p>
          </div>
          <div className="flex flex-col sm:flex-row items-stretch sm:items-center gap-3 shrink-0">
            <Link
              to="/kontakt"
              className="inline-flex items-center justify-center gap-2 rounded-sm bg-[#fd7302] px-5 py-2.5 text-sm font-semibold text-white transition-colors hover:bg-[#e06500] focus:outline-none focus:ring-2 focus:ring-[#fd7302] focus:ring-offset-2"
            >
              <span>Gå til Martin Krogh</span>
              <i className="fa-solid fa-arrow-right text-xs" aria-hidden="true" />
            </Link>
            <Link
              to="/kontakt"
              className="inline-flex items-center justify-center gap-2 rounded-sm border border-[#010b27] bg-white px-5 py-2.5 text-sm font-semibold text-[#010b27] transition-colors hover:bg-slate-50 focus:outline-none focus:ring-2 focus:ring-[#010b27] focus:ring-offset-2"
            >
              <span>Udfyld kontaktformular</span>
            </Link>
          </div>
        </div>
      </aside>
    );
  }

  // Sidebar / Column Box
  return (
    <aside
      aria-label="Skattefaglig rådgivning"
      className={`rounded-md border border-slate-200 bg-slate-50 p-5 ${className}`}
    >
      <div className="flex items-center gap-2 text-[11px] font-bold tracking-widest text-[#fd7302] uppercase">
        <i className="fa-solid fa-shield-halved" aria-hidden="true" />
        <span>Faglig vejledning</span>
      </div>
      <h3 className="mt-2 font-serif text-xl font-bold text-[#010b27]">
        Uforpligtende initiel kontakt og vurdering
      </h3>
      <p className="mt-2 text-xs sm:text-sm text-slate-600 leading-relaxed">
        Ring til Martin eller skriv til ham ved at udfylde kontaktformular nedenfor og tryk på send.
      </p>
      <div className="mt-4 pt-3 border-t border-slate-200 flex flex-col gap-2">
        <a
          href="tel:61444604"
          className="inline-flex items-center justify-center gap-2 rounded-sm bg-[#010b27] px-4 py-2.5 text-xs font-semibold text-white transition-colors hover:bg-[#fd7302]"
        >
          <i className="fa-solid fa-phone text-xs" aria-hidden="true" />
          <span>Ring: 61 44 46 04</span>
        </a>
        <Link
          to="/kontakt"
          className="inline-flex items-center justify-center gap-2 rounded-sm border border-[#010b27] bg-white px-4 py-2 text-xs font-semibold text-[#010b27] transition-colors hover:bg-[#010b27] hover:text-white"
        >
          <i className="fa-solid fa-envelope text-xs" aria-hidden="true" />
          <span>Gå til kontaktformular</span>
        </Link>
      </div>
    </aside>
  );
}
